import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ValidatedTextArea } from '../../../components/ValidatedTextArea';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';
import { ProjectStatus } from '../../projects/projects.model';
import { useProjectDetailsPermissions } from '../projectDetails.permissions';

interface IProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onNameBlur: () => Promise<void>;
  onDescriptionBlur: () => Promise<void>;
  nameMaxLength: number;
  nameStatus: InputStatus;
  descriptionMaxLength: number;
  descriptionStatus: InputStatus;
  projectStatus: ProjectStatus;
}

export const ProjectHeaderForm = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const canEditProject = useProjectDetailsPermissions().canEditProject(props.projectStatus);
  return (
    <>
      {canEditProject.allowed ? (
        <>
          <div>
            <span className='project-details-header-label'>{t('project_name')}</span>
            <ValidatedTextInput
              id='project-name-textbox'
              className='project-name-textbox'
              type={'text'}
              placeholder={t('type_your_project_name_here')}
              maxLength={props.nameMaxLength}
              value={props.name}
              onChange={props.onNameChange}
              onBlur={() => {
                void props.onNameBlur();
              }}
              isValid={props.nameStatus.isValid}
              feedbacks={props.nameStatus.errorCodes}
            />
          </div>
          <div>
            <span className='project-details-header-label'>{t('description')}</span>
            <ValidatedTextArea
              id='project-description-textbox'
              className='project-description-textbox'
              placeholder={t('type_your_project_description_here')}
              maxLength={props.descriptionMaxLength}
              value={props.description}
              onChange={props.onDescriptionChange}
              onBlur={() => {
                void props.onDescriptionBlur();
              }}
              isValid={props.descriptionStatus.isValid}
              feedbacks={props.descriptionStatus.errorCodes}
            />
          </div>
        </>
      ) : (
        <>
          <h1>{props.name}</h1>
          <p>{props.description}</p>
        </>
      )}
    </>
  );
});
